export enum OfferSelectButtonStatus {
  Select = 'select',
  Selecting = 'selecting',
  Selected = 'selected'
}
